(function(){
    'use strict';
    angular.module('Filters')
    .filter('theSameCurrency', () => {
        /**
         * Get only the fuel levies that has the same currency with the service profile
         * 
         * @param { [obj] } data array of fuel levies that will be filtered.
         * @param { string } currency service profile currency type ex. AUD, NZD USD
         * 
         * @return { [obj] } filtered data
         */
        return (data, currency) => {
            let newData = data.filter((value)=>{
                if(currency == 'AUD') { 
                    return value.currency === currency || value.currency === null;
                } else {
                    return value.currency === currency;
                }
            });
            return newData;
        }
    });
})()


// WEBPACK FOOTER //
// ./js/filters/theSameCurrency.js